import React from "react";
import moment from "moment";

import { Box, Paper, Typography, useTheme } from "@material-ui/core";
import { UserNotification } from "../../../models/User";

import { NotificationsTableProps } from "./types";
import useStyles from "./styles";
import MaterialTable from "@material-table/core";
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import { prepareExportData } from "../../../utils";
import { useI18n } from "../../../hooks/useI18n";

const NotificationsCollection = ({
  notifications,
  screenSize
}: NotificationsTableProps) => {
  const styles = useStyles();
  const theme = useTheme();
  const { t } = useI18n();

  const rowsPerPage = screenSize === "desktop" ? 10 : 5;
  const exportDataFormat = [{ type: "datetime", index: 2 }];

  return (
    <MaterialTable
      columns={[
        {
          title: "Title",
          field: "title",
          render: (row: any) => (
            <Box>
              <Typography
                variant={"body2"}
                style={{ fontWeight: theme.typography.fontWeightBold }}
              >
                {row.title}
              </Typography>
              <Typography variant={"body2"}>{row.body}</Typography>
            </Box>
          )
        },
        {
          title: "Content",
          field: "body",
          hidden: true,
          export: true
        },
        {
          title: "Created",
          field: "created",
          render: (row: any) => moment(row.created).format("YYYY-MM-DD HH:mm")
        }
      ]}
      data={notifications}
      components={{
        Container: props => <Paper {...props} elevation={0} />
      }}
      options={{
        showTitle: false,
        paging: true,
        pageSize: rowsPerPage, // make initial page size
        emptyRowsWhenPaging: false, // To avoid of having empty rows
        search: true,
        pageSizeOptions: [10, 20, 50, 100],
        exportMenu:
          screenSize === "desktop"
            ? [
                {
                  label: t("common.export.exportPdf"),
                  exportFunc: (cols, data) => {
                    const d = prepareExportData(cols, data, exportDataFormat);
                    return ExportPdf(d[0], d[1], `Discounts`);
                  }
                },
                {
                  label: t("common.export.exportCsv"),
                  exportFunc: (cols, data) => {
                    const d = prepareExportData(cols, data, exportDataFormat);
                    return ExportCsv(d[0], d[1], `Discounts`);
                  }
                }
              ]
            : [],
        exportAllData: true
      }}
    />
  );
};

export default NotificationsCollection;
